import {Grid} from '@mui/material';
import React, {PropsWithChildren} from 'react';
import {MandatoryChildren} from '../../utils/utils';

export function FormRow({children}: PropsWithChildren<MandatoryChildren>) {
    return (<Grid container spacing={2} sx={theme => ({marginTop: theme.spacing(1)})}>{children}</Grid>);
}
